import { SxProps, Theme } from '@mui/material'

export enum ModalLocation {
  left = 'left',
  right = 'right',
}

export type ContactUsModalProps = {
  anchorEl: HTMLElement | null
  position: ModalLocation
}

export type ContactUsButtonProps = {
  position?: ModalLocation
  small?: boolean
  fullWidth?: boolean
  sx?: SxProps<Theme>
  className?: string
}

export type ContactUsModalStateType = {
  isOpen: boolean
}

export enum RelatedFeatureTypeEnum {
  Area = 'area', // Feature; Area just for users
  Platform = 'platform',
}
